// try {
//   document.addEventListener("DOMContentLoaded", () => {
//     const productEl = document.querySelector(".custom-product");
//     if (!productEl) return;

//     const swiperContainer = document.querySelector(".product-swiper-container");
//     const allImages = JSON.parse(productEl.getAttribute("product-images-json") || "[]");

//     /* ---------------------- DESTROY SWIPER ---------------------- */
//     function safeDestroySwiper() {
//       try {
//         if (swiperContainer && swiperContainer.swiper) {
//           swiperContainer.swiper.destroy(true, true);
//           swiperContainer.swiper = null;
//         }
//       } catch (err) {}
//     }

//     /* ---------------------- BUILD SLIDE HTML ---------------------- */
//     function buildSlideHtml(img) {
//       return `
//         <picture>
//           <img src="${img.src}" loading="eager" alt="${img.alt || ''}">
//         </picture>
//         <div class="custom-product-img-enlarger-icon">
//           <svg fill="#000000" width="800px" height="800px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
//             <path d="M21.434 11.975l8.602-8.549-0.028 4.846c-0.009 0.404 0.311 0.755 0.716 0.746l0.513-0.001c0.404-0.009 0.739-0.25 0.748-0.654l0.021-7.219c0-0.007-0.027-0.012-0.027-0.019l0.040-0.366c0.004-0.203-0.044-0.384-0.174-0.513-0.13-0.131-0.311-0.21-0.512-0.204l-0.366 0.009c-0.007 0-0.012 0.003-0.020 0.004l-7.172-0.032c-0.404 0.009-0.738 0.343-0.747 0.748l-0.001 0.513c0.061 0.476 0.436 0.755 0.84 0.746l4.726 0.013-8.572 8.52c-0.39 0.39-0.39 1.024 0 1.415s1.023 0.39 1.414 0zM10.597 20.025l-8.602 8.523 0.027-4.82c0.010-0.404-0.312-0.756-0.716-0.747l-0.544 0.001c-0.405 0.010-0.739 0.25-0.748 0.654l-0.021 7.219c0 0.007 0.028 0.011 0.028 0.019l-0.040 0.365c-0.005 0.203 0.043 0.385 0.174 0.514 0.129 0.131 0.311 0.21 0.512 0.205l0.366-0.009c0.007 0 0.012-0.003 0.020-0.003l7.203 0.032c0.404-0.010 0.738-0.344 0.748-0.748l0.001-0.514c-0.062-0.476-0.436-0.755-0.84-0.746l-4.726-0.012 8.571-8.518c0.39-0.39 0.39-1.023 0-1.414s-1.023-0.391-1.413-0zM32.007 30.855l-0.021-7.219c-0.009-0.404-0.343-0.645-0.747-0.654l-0.513-0.001c-0.404-0.009-0.725 0.343-0.716 0.747l0.028 4.846-8.602-8.549c-0.39-0.39-1.023-0.39-1.414 0s-0.39 1.023 0 1.414l8.571 8.518-4.726 0.012c-0.404-0.009-0.779 0.27-0.84 0.746l0.001 0.514c0.009 0.404 0.344 0.739 0.747 0.748l7.172-0.032c0.008 0 0.013 0.003 0.020 0.003l0.366 0.009c0.201 0.005 0.384-0.074 0.512-0.205 0.131-0.129 0.178-0.311 0.174-0.514l-0.040-0.365c0-0.008 0.027-0.012 0.027-0.019zM3.439 2.041l4.727-0.012c0.404 0.009 0.778-0.27 0.84-0.746l-0.001-0.513c-0.010-0.405-0.344-0.739-0.748-0.748l-7.204 0.031c-0.008-0.001-0.013-0.004-0.020-0.004l-0.366-0.009c-0.201-0.005-0.383 0.074-0.512 0.204-0.132 0.13-0.179 0.31-0.174 0.514l0.040 0.366c0 0.007-0.028 0.012-0.028 0.020l0.021 7.219c0.009 0.404 0.343 0.645 0.748 0.654l0.545 0.001c0.404 0.009 0.724-0.342 0.715-0.746l-0.028-4.819 8.602 8.523c0.39 0.39 1.024 0.39 1.414 0s0.39-1.024 0-1.415z"></path>
//           </svg>
//         </div>
//       `;
//     }

//     /* ---------------------- INIT SWIPER ---------------------- */
//     function initSwiper(loop = true) {
//       try {
//         swiperContainer.autoHeight = true;
//         swiperContainer.loop = loop;

//         swiperContainer.pagination = {
//           el: ".custom-pagination",
//           clickable: true,
//           renderBullet: function (index, className) {
//             return `<span class="${className}">0${index + 1}</span>`;
//           },
//         };

//         swiperContainer.navigation = {
//           nextEl: ".swiper-button-next",
//           prevEl: ".swiper-button-prev",
//         };

//         swiperContainer.initialize();

//         if (swiperContainer.swiper) {
//           swiperContainer.swiper.update();
//           swiperContainer.swiper.slideTo(0);
//         }
//       } catch (err) {
//         console.warn("Swiper init error:", err);
//       }
//     }

//     /* ---------------------- SHOW IMAGES BASED ON COLOR ---------------------- */
//     function showImagesForColor(color) {
//       if (!color) return;

//       const colorImages = allImages.filter(img =>
//         img.alt?.toLowerCase().includes(`color: ${color.toLowerCase()}`)
//       );

//       const sharedImages = allImages.filter(img =>
//         img.alt?.toLowerCase().includes("common image")
//       );

//       let displayImages = colorImages.length
//         ? [...colorImages, ...sharedImages]
//         : [...allImages];

//       safeDestroySwiper();
//       swiperContainer.innerHTML = "";

//       displayImages.forEach(img => {
//         const slide = document.createElement("swiper-slide");
//         slide.className = "product-swiper-slide";
//         slide.innerHTML = buildSlideHtml(img);
//         swiperContainer.appendChild(slide);
//       });

//       initSwiper(displayImages.length > 1);
//     }

//     /* ---------------------- LISTEN TO YOUR COLOR RADIO BUTTONS ---------------------- */
//     document.addEventListener("change", (e) => {
//       if (e.target.name === "productColor") {
//         const colorValue = e.target.value;
//         showImagesForColor(colorValue);
//       }
//     });

//     /* ---------------------- LOAD DEFAULT SELECTED COLOR ---------------------- */
//     setTimeout(() => {
//       const checkedColor = document.querySelector('input[name="productColor"]:checked');
//       if (checkedColor) {
//         showImagesForColor(checkedColor.value);
//       }
//     }, 500);
//   });
// } catch (error) {
//   console.log(error);
// }

// Product Availability
try {
  document.addEventListener("DOMContentLoaded", () => {
    const productEl = document.querySelector(".custom-product");
    if (!productEl) return;

    const variants = JSON.parse(productEl.getAttribute("product-variant-json") || "[]");
    const sizeRadios = document.querySelectorAll('input[name="productSizes"]');
    const colorRadios = document.querySelectorAll('input[name="productColor"]');

    // Helper: find variant by selected options
    function findVariant(selected) {
      return variants.find(v =>
        v.options.every((opt, i) => !selected[i] || opt === selected[i])
      );
    }

    function updateAvailability() {
      const selectedSize = document.querySelector('input[name="productSizes"]:checked')?.value;
      const selectedColor = document.querySelector('input[name="productColor"]:checked')?.value;

      if (selectedColor && sizeRadios.length) {
        sizeRadios.forEach(radio => {
          const match = variants.find(v =>
            v.options[0] === radio.value && v.options[1] === selectedColor
          );
          if (!match || match.available === false || match.inventory_quantity <= 0) {
            radio.disabled = true;
            radio.closest("label").classList.add("disabled");
          } else {
            radio.disabled = false;
            radio.closest("label").classList.remove("disabled");
          }
        });
      }

      if (selectedSize && colorRadios.length) {
        colorRadios.forEach(radio => {
          const match = variants.find(v =>
            v.options[0] === selectedSize && v.options[1] === radio.value
          );
          if (!match || match.available === false || match.inventory_quantity <= 0) {
            radio.disabled = true;
            radio.closest("label").classList.add("disabled");
          } else {
            radio.disabled = false;
            radio.closest("label").classList.remove("disabled");
          }
        });
      }
    }

    [...sizeRadios, ...colorRadios].forEach(radio => {
      radio.addEventListener("change", updateAvailability);
    });

    updateAvailability();
  });  
} catch (error) {
  console.log(error)
}

//Product Page Qunatity
try {
  let quantityInput = document.querySelector(".product-quantity-input");
  let plusQuantityBtn = document.querySelector(".product-quantity-plus-btn");
  let minusQuantityBtn = document.querySelector(".product-quantity-minus-btn");
  plusQuantityBtn.addEventListener("click", () => {
    let currentValue = parseInt(quantityInput.value) || 0;
    let maxInputValue = parseInt(quantityInput.getAttribute("max")) || 0;
    // if (currentValue < maxInputValue) {
      quantityInput.value = currentValue + 1;
    // } else if (currentValue == maxInputValue) {
    //   if (window.location.href.includes("/ar")) {
    //     document.querySelector(
    //       ".notification-bar-bottom p"
    //     ).textContent = `لا تتوفر عناصر كافية. متبقي ${maxInputValue} فقط.`;
    //   } else {
    //     document.querySelector(
    //       ".notification-bar-bottom p"
    //     ).textContent = `Not enough items available. Only ${maxInputValue} left.`;
    //   }
    //   document.querySelector(".notification-bar-bottom").style.bottom = "0%";
    //   setTimeout(() => {
    //     document.querySelector(".notification-bar-bottom").style.bottom =
    //       "-100%";
    //   }, 5000);
    // }
  });
  minusQuantityBtn.addEventListener("click", () => {
    let currentValue = parseInt(quantityInput.value) || 0;
    if (currentValue > 1) {
      quantityInput.value = currentValue - 1;
    }
  });
  document
    .querySelector(".notification-bar-bottom div")
    .addEventListener("click", () => {
      document.querySelector(".notification-bar-bottom").style.bottom = "-100%";
    });
} catch (error) {
  console.log(error);
}

//Product Page Max Quantity
// try {
//     const qtyInput = document.querySelector('.product-quantity-input');
//     const sizeRadios = document.querySelectorAll('input[name="productSizes"]');

//     function syncMaxFromSize() {
//       const checked = document.querySelector('input[name="productSizes"]:checked');
//       const max = Number(checked?.dataset.max ?? 0);

//       qtyInput.setAttribute('max', String(max));

//       // If current qty is higher than stock, clamp it down
//       if (qtyInput.value > max) {
//         qtyInput.value = max > 0 ? max : 0;
//       }
//     }

//     sizeRadios.forEach((r) => r.addEventListener('change', syncMaxFromSize));
//     syncMaxFromSize(); // run once on load
// } catch (error) {}

//Product Page Desc
try {
  let productDescription = document.querySelector(".product-description");
  let productDescriptionWrapper = document.querySelectorAll(
    ".product-description-wrapper"
  );
  productDescriptionWrapper.forEach((btn)=>{
    btn.addEventListener('click',(e)=>{
      if(e.target.closest(".product-description")) return;
      e.stopPropagation();
      btn.querySelector('.product-description').classList.toggle('product-desc-class');
    })
  })
} catch (error) {
  console.log(error);
}

//Product Page Size Chart
try {
  let sizeChartCloseBtn = document.querySelector(".size-chart-close-btn");
  let sizeChart = document.querySelector(".pj-set-size-chart-container");
  let openSizeChartBtn = document.querySelector(".pj-set-size-chart-wrapper p");
  sizeChart.style.opacity = "0";
  sizeChart.style.zIndex = "-5";
  openSizeChartBtn.addEventListener("click", () => {
    if (sizeChart.style.opacity == "0") {
      sizeChart.style.opacity = "1";
      sizeChart.style.zIndex = "9999";
    }
  });
  sizeChartCloseBtn.addEventListener("click", () => {
    if (sizeChart.style.opacity == "1") {
      sizeChart.style.opacity = "0";
      sizeChart.style.zIndex = "-5";
    }
  });
} catch (error) {
  console.log(error);
}

//Product Page Buttons
// try {
//   let productVariantWrapper = document.querySelector(".product-size-variant");
//   if (productVariantWrapper.children.length == 1) {
//     document.querySelector(".product-quantity").style.display = "none";
//     document.querySelector(".product-variants-wrapper").style.display = "none";
//     document.querySelector(".product-add-to-cart button").textContent =
//       "OUT OF STOCK";
//     document.querySelector(".product-add-to-cart button").disabled = "true";
//     document.querySelector(".buy-product-btn").disabled = "true";
//   }
// } catch (error) {
//   console.log(error);
// }

//Enlarger
try {
  let enlargerOpenBtn = document.querySelectorAll(
    ".custom-product-img-enlarger-icon"
  );
  let enlargerCloseBtn = document.querySelector(".enlarger-close-btn");
  let enlargerWrapper = document.querySelector(".custom-product-img-enlarger");
  let enlargerCon = document.querySelector(
    ".custom-product-img-enlarger-container"
  );

  document.addEventListener('click',(e)=>{
    let btn = e.target.closest(".custom-product-img-enlarger-icon");
    if(!btn) return;
    let closestImgSrc = btn.previousElementSibling.querySelector("img").getAttribute("src");
    // console.log(closestImgSrc);
    let img = document.createElement("img");
    img.setAttribute("draggable", "false");
    img.setAttribute("src", closestImgSrc);
    // console.log(img);
    img.classList.add("product-img-class");
    enlargerWrapper.innerHTML = "";
    enlargerWrapper.append(img);
    enlargerCon.classList.add("custom-product-img-enlarger-container-class");
    enableImageDrag(img);
  })

  enlargerCloseBtn.addEventListener("click", () => {
    enlargerCon.classList.remove("custom-product-img-enlarger-container-class");
  });

  function enableImageDrag(img) {
  let isDraggable = false;
  let startX, startY, initialLeft, initialTop;

  img.style.position = "absolute";
  img.style.top = "50%";
  img.style.left = "50%";
  if(window.innerWidth > 768){
    img.style.transform = "translate(-50%, -50%) scale(1.5)";
  }else{
    img.style.transform = "translate(-50%, -50%) scale(1)";
  }
  img.style.cursor = "grab";

  img.addEventListener("mousedown", (e) => {
    isDraggable = true;
    img.style.transition = "none";
    img.style.cursor = "grabbing";

    // Get current position of the image (after transforms)
    const rect = img.getBoundingClientRect();

    // Calculate starting mouse position and element offsets
    startX = e.clientX;
    startY = e.clientY;

    // Compute initial top/left in pixels relative to parent container
    const computedStyle = window.getComputedStyle(img);
    initialLeft = parseFloat(computedStyle.left);
    initialTop = parseFloat(computedStyle.top);

    document.body.style.userSelect = "none";
  });

  window.addEventListener("mousemove", (e) => {
    if (!isDraggable) return;

    // Delta from initial click
    const dx = e.clientX - startX;
    const dy = e.clientY - startY;

    // Move image smoothly while maintaining scale
    img.style.left = `${initialLeft + dx}px`;
    img.style.top = `${initialTop + dy}px`;
     if(window.innerWidth > 768){
    img.style.transform = "translate(-50%, -50%) scale(1.5)";
  }else{
    img.style.transform = "translate(-50%, -50%) scale(1)";
  }
  });

  window.addEventListener("mouseup", () => {
    if (isDraggable) {
      isDraggable = false;
      img.style.cursor = "grab";
      document.body.style.userSelect = "";
      img.style.transition = ".3s ease";
      // Snap back to center if desired
      img.style.top = `50%`;
      img.style.left = `50%`;
       if(window.innerWidth > 768){
    img.style.transform = "translate(-50%, -50%) scale(1.5)";
  }else{
    img.style.transform = "translate(-50%, -50%) scale(1)";
  }
    }
  });
  }
} catch (error) {
  console.log(error);
}

//Image Shift
try {
  let variants = JSON.parse(document.querySelector(".custom-product").getAttribute("product-variant-json"));
  let radios = document.querySelectorAll('.product-variants-wrapper input[type="radio"]');

  // console.log(radios);

  function updateImgSlide() {
    let selectedVariant = [];

    document.querySelectorAll('.product-variants-wrapper input[type="radio"]:checked').forEach((radio) => {
      selectedVariant.push(radio.value);
    });

    // console.log(selectedVariant);
    // console.log(variants);


    let matchedVariant = variants.find((v)=> 
      selectedVariant.every((opt,i)=> v[`option${i + 1}`] === opt)
    )

    // console.log(matchedVariant);

    if(!matchedVariant) return;
    
    let targetedImage = document.querySelector(`[image-id="${matchedVariant.featured_image.id}"]`);
    if(targetedImage){
      let index = [...targetedImage.parentElement.children].indexOf(targetedImage);

      
      let swiperEl = document.querySelector(".product-swiper-container");
      swiperEl.swiper.slideTo(index);
    }
  }

  radios.forEach((radio) => {
    radio.addEventListener("change", () => {
      updateImgSlide();
    });
  });
} catch (error) {
  console.log(error);
}

//Delivery Status
try {
  let orderDate = document.querySelector(".order-date");
  let shippingTime = document.querySelector(".shipping-time");
  let deliveryDate = document.querySelector(".delivery-date");
  let product = document.querySelector(".custom-product");

  let shipStartAtr = Number(product.getAttribute("ship-start"));
  let shipEndAtr = Number(product.getAttribute("ship-end"));
  let deliverAtr = Number(product.getAttribute("deliver"));

  // console.log(typeof shipStartAtr , shipEndAtr, deliverAtr)

  let today = new Date();
  let day = today.toLocaleDateString('en-US', { weekday: 'short' });

  // helper to format date nicely
  function formatDate(date) {
    let dayNum = date.getDate();
    let month = date.toLocaleString('default', { month: 'short' });

    // ordinal suffix
    let suffix = "th";
    if (dayNum % 10 === 1 && dayNum !== 11) suffix = "st";
    else if (dayNum % 10 === 2 && dayNum !== 12) suffix = "nd";
    else if (dayNum % 10 === 3 && dayNum !== 13) suffix = "rd";

    return `${month} ${dayNum}${suffix}`;
  }

  // set order date
  orderDate.innerHTML = formatDate(today);

  // create cloned date objects for adding days
  function addDays(baseDate, days) {
    let newDate = new Date(baseDate);
    newDate.setDate(baseDate.getDate() + days);
    return newDate;
  }

  let shipStart, shipEnd, deliver;

  // your same weekday logic but with Date objects
  if (day === 'Mon') {
    shipStart = addDays(today, shipStartAtr);
    shipEnd = addDays(today, shipEndAtr);
    deliver = addDays(today, deliverAtr);
  } else if (day === 'Tue') {
    shipStart = addDays(today, shipStartAtr);
    shipEnd = addDays(today, shipEndAtr);
    deliver = addDays(today, deliverAtr);
  } else if (day === 'Wed') {
    shipStart = addDays(today, shipStartAtr);
    shipEnd = addDays(today, shipEndAtr);
    deliver = addDays(today, deliverAtr);
  } else if (day === 'Thu') {
    shipStart = addDays(today, shipStartAtr);
    shipEnd = addDays(today, shipEndAtr);
    deliver = addDays(today, deliverAtr);
  } else if (day === 'Fri') {
    shipStart = addDays(today, shipStartAtr);
    shipEnd = addDays(today, shipEndAtr);
    deliver = addDays(today, deliverAtr);
  } else if (day === 'Sat') {
    shipStart = addDays(today, shipStartAtr);
    shipEnd = addDays(today, shipEndAtr);
    deliver = addDays(today, deliverAtr);
  } else {
    shipStart = addDays(today, shipStartAtr);
    shipEnd = addDays(today, shipEndAtr);
    deliver = addDays(today, deliverAtr);
  }

  // if(shipStartAtr || shipEndAtr || deliverAtr){
  //   shipStart = addDays(today, shipStartAtr);
  //   shipEnd = addDays(today, shipEndAtr);
  //   deliver = addDays(today, deliverAtr);
  // }

  shippingTime.innerHTML = `${formatDate(shipStart)} - ${formatDate(shipEnd)}`;
  deliveryDate.innerHTML = formatDate(deliver);
} catch (error) {
  console.log(error);
}

//Product Review
try {
  let reviewSwiperContainer = document.querySelector(".review-swiper-container");
  let reviewerNames = document.querySelectorAll(".jdgm-rev__author");
  let reviews = document.querySelectorAll(".jdgm-rev__body p");
  let reviewRatings = document.querySelectorAll(".jdgm-rev__rating");

  let reviewerNameArr = [];
  let reviewsArr = [];
  let reviewRatingsArr = [];

  reviewerNames.forEach((name)=>{
    reviewerNameArr.push(name.textContent);
  })
  reviews.forEach((review)=>{
    reviewsArr.push(review.textContent);
  })
  reviewRatings.forEach((rating)=>{
    reviewRatingsArr.push(rating);
  })

  // console.log(reviewerNameArr)
  // console.log(reviewsArr)
  // console.log(reviewRatingsArr)

  let reviewObjects = [];

  for (let i = 0; i < reviewerNameArr.length; i++) {
    reviewObjects.push({
      name: reviewerNameArr[i],
      review: reviewsArr[i],
      rating: reviewRatingsArr[i]
    });
  }

  if(reviewObjects.length == 0){
    document.querySelector(".custom-product-reviews-slider-wrapper").style.display = 'none';
  }else{
    reviewObjects.forEach((reviews)=>{
      let reviewSwiperSlide = document.createElement("swiper-slide");
      reviewSwiperSlide.innerHTML = `
          <div class="review-img-wrapper">
              <svg
                fill="#000000"
                width="100px"
                height="100px"
                viewBox="0 0 32 32"
                xmlns="http://www.w3.org/2000/svg"
                stroke="#000000"
                stroke-width="0.00032"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M16 15.503A5.041 5.041 0 1 0 16 5.42a5.041 5.041 0 0 0 0 10.083zm0 2.215c-6.703 0-11 3.699-11 5.5v3.363h22v-3.363c0-2.178-4.068-5.5-11-5.5z"></path></g>
              </svg>
            </div>
          <div class="review-txt-wrapper">
            <p>${reviews.review}</p>
            <div class="review-name-rating-wrapper">
              <p>— ${reviews.name}</p>
              <span>
              ${reviews.rating.innerHTML}
              </span>
            </div>
          </div>
      `

      reviewSwiperContainer.append(reviewSwiperSlide);
    })
  }
} catch (error) {
  console.log(error);
}

// Bundle Prices
// document.addEventListener("DOMContentLoaded",()=>{
//   setTimeout(() => {
//     try {
//       let orgPrice = document.querySelectorAll(".kaching-bundles__bar-price");
//       let compPrice = document.querySelectorAll(".kaching-bundles__bar-full-price");
      
//       function changeCurrency(price) {
//         let prevOrgPrice = price.querySelector('span').textContent.replace('Dhs.','');
//         price.querySelector('span').classList.add('currency-price');
//         price.querySelector('span').setAttribute('data-aed-price', `${prevOrgPrice.trim()}`);
//       }

//       compPrice.forEach((price)=>{
//         changeCurrency(price);
//       })  

//       orgPrice.forEach((price)=>{
//         changeCurrency(price);
//       })

//       const savedCurrency = localStorage.getItem("selectedCurrency") || "AED";
//       updatePrices(savedCurrency);
//     } catch (error) {
//       console.log(error);
//     }  
//   }, 5000);
// })

//Bundle Options
// document.addEventListener("DOMContentLoaded",()=>{
//   try {
//     setTimeout(() => {
//       // Size
//       let themeSizeRadios = document.querySelectorAll("input[name='productSizes']");
//       themeSizeRadios.forEach((radio)=>{
//         radio.addEventListener('click',()=>{
//           let selectedRadio = document.querySelector("input[name='productSizes']:checked");
//           let selectedKachingBundle = document.querySelector(".kaching-bundles__bar--selected");
//           let selectedKachingBundleVariantsWrapper = selectedKachingBundle.querySelectorAll(".kaching-bundles__bar-variant-selects");

//           // console.log(selectedKachingBundle)
//           // console.log(selectedKachingBundleVariantsWrapper)

//           selectedKachingBundleVariantsWrapper.forEach((wrapper)=>{
//             let kachingBundleSizeSelect = wrapper.querySelector("select[data-name='Size']");
//             console.log(kachingBundleSizeSelect);
//             kachingBundleSizeSelect.value = selectedRadio.value;
//           })

//         })
//       })

//       // Color
//       let themeColorVariantPicker = document.querySelectorAll("input[name='productColor']");
//       themeColorVariantPicker.forEach(radio => {
//         radio.addEventListener("click", () => {

//           let selectedColorText = radio.value.toLowerCase();

//           let selectedBundle = document.querySelector(".kaching-bundles__bar--selected");
//           let wrappers = Array.from(selectedBundle.querySelectorAll(".kaching-bundles__bar-variant-selects"));

//           function processWrapper(index) {
//             if (index >= wrappers.length) return; // finished all

//             let wrapper = wrappers[index];
//             let appColorButton = wrapper.querySelector("div[data-name='Color'] span[role='button']");
//             if (!appColorButton) return processWrapper(index + 1);

//             appColorButton.click(); // open dropdown

//             let waitForMenu = setInterval(() => {
//               // get the global dropdown (NOT inside wrapper!)
//               let dropdownOptions = document.querySelectorAll(".kaching-bundles__swatch-dropdown__option");

//               if (dropdownOptions.length > 0) {
//                 clearInterval(waitForMenu);

//                 dropdownOptions.forEach(option => {
//                   let label = option.textContent.trim().toLowerCase();
//                   if (label === selectedColorText) {
//                     option.click(); // select this color
//                   }
//                 });

//                 // close dropdown
//                 // appColorButton.click();

//                 // process next wrapper after tiny delay
//                 setTimeout(() => {
//                   processWrapper(index + 1);
//                 }, 150);
//               }
//             }, 40);
//           }

//           processWrapper(0); // start sequence
//         });
//       });
//     }, 2000);
//   } catch (error) {
//     console.log(error); 
//   }
// })

// Bundle price and qty
document.addEventListener("DOMContentLoaded",()=>{
  setTimeout(() => {
    try {
      let hasBundle = document.querySelector(".kaching-bundles__bars");
      if(hasBundle){
        // console.log("hello")
        let productPrice = document.querySelector(".product-price");
        let productQty = document.querySelector(".product-quantity");

        if(productPrice){
        productPrice.style.display = 'none';
        }
        productQty.style.display = 'none';
        // console.log("hello")
      }     
    } catch (error) {console.log(error)}
  }, 500);
})